import React, { useState } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';

const PREVIEW_COUNT = 20;

const normalizeTargetIdsList = (targetIds) => {
  if (Array.isArray(targetIds)) {
    return targetIds.filter((id) => id != null && id !== '');
  }
  return [];
};

const TargetIdsViewBlock = ({ targetIds, ruleType }) => {
  const [expanded, setExpanded] = useState(false);

  const label = localization.targetIds;
  const ids = normalizeTargetIdsList(targetIds);
  const count = ids.length;
  const idsText = ids.join(', ');

  if (ruleType === 'all') {
    return (
      <div className="col-md-6 mb-3">
        <div className="client-dashboard-banner-detail-label">{label}</div>
        <div className="client-dashboard-banner-detail-value">
          {localization.dynamicContentViewAllProjects}
        </div>
      </div>
    );
  }

  if (count === 0) {
    return (
      <div className="col-md-6 mb-3">
        <div className="client-dashboard-banner-detail-label">{label}</div>
        <div className="client-dashboard-banner-detail-value">—</div>
      </div>
    );
  }

  const needsToggle = count > PREVIEW_COUNT;
  const previewText = needsToggle
    ? `${ids.slice(0, PREVIEW_COUNT).join(', ')}, …`
    : idsText;

  return (
    <div className={`mb-3 ${needsToggle ? 'col-md-12' : 'col-md-6'} dynamic-contents-view-target-ids`}>
      <div className="client-dashboard-banner-detail-label">{label}</div>
      {expanded ? (
        <div className="dynamic-contents-view-target-ids-panel">{idsText}</div>
      ) : (
        <div className="client-dashboard-banner-detail-value">{previewText}</div>
      )}
      {needsToggle ? (
        <button
          type="button"
          className="dynamic-contents-view-target-ids-toggle btn btn-link p-0"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? localization.showLess : localization.showMore}
        </button>
      ) : null}
    </div>
  );
};

TargetIdsViewBlock.propTypes = {
  targetIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  ruleType: PropTypes.string,
};

TargetIdsViewBlock.defaultProps = {
  targetIds: [],
  ruleType: 'all',
};

export default TargetIdsViewBlock;
